var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.18 59.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.67,12.1h3V24.53c0,1.08.3,1.39,1.36,1.39h5.15c1.1,0,1.38-.28,1.38-1.41,0-3.9,0-7.79,0-11.68V12.1h2.28c1,0,2.08,0,3.12,0,.49,0,.61-.27.34-.68-.07-.11-.17-.2-.25-.31L25.7,0h-.34C24.15,1.45,23,2.91,21.75,4.36L16,11.26a2.26,2.26,0,0,0-.25.66,3,3,0,0,0,.63.17C17.17,12.11,17.92,12.1,18.67,12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.77,56q-12.32-8.91-24.65-17.8a.7.7,0,0,0-1,0c-3.69,2.7-7.39,5.37-11.09,8Q7.26,51.21.48,56.13A1.11,1.11,0,0,0,0,56.8c0,.79,0,1.58,0,2.41H51.17c0-.84,0-1.65,0-2.45A1.09,1.09,0,0,0,50.77,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,52.23,15.86,40.92,3.6,32.17l3.46-2.53c3.4-2.47,6.8-4.93,10.19-7.41.19-.13.41-.37.41-.56,0-1.48,0-3,0-4.57l-.52.34q-8.33,6-16.67,12a1.12,1.12,0,0,0-.49,1Q0,41,0,51.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.47,17c0,1.52,0,2.92,0,4.33a.86.86,0,0,0,.41.81C37,24.41,40.18,26.7,43.33,29l4.36,3.17L35.36,41,51.14,52.2c0-.22,0-.31,0-.41q0-10.78,0-21.57a.89.89,0,0,0-.48-.78L34,17.37C33.87,17.25,33.7,17.15,33.47,17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.e6e24915.svg";
export { ForwardRef as ReactComponent };